<div style="min-width:500px;">
  <div style="width:98%">
    <span> <button class="btn btn border" (click)="saveSignType()">Spara</button> <button class="btn btn border" style="margin-left:20px;" (click)="cancel()">Avbryt</button></span>
    <br>
    <hr /><br>
    <form [formGroup]="form">
      <div class="row">
        <div class="col-md-6">
          <label>
            Namn
          </label>
          <input id="name" type="text" class="form-control form-control-sm" formControlName="name">
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label>
            Sorteringsordning
          </label>
          <input id="sort" type="text" class="form-control form-control-sm" formControlName="sort">
        </div>
      </div>
    </form>
  </div>
</div>